/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */
import { classNames } from '../utils/UNSAFE_classNames';
import { multiVariantStyles, styles } from './themes/DividerStyles.css';

// TODO -  Expose props once vertical orientation is supported
type DividerProps = {
  /**
   * Divider's orientation.
   */
  orientation?: 'horizontal';
};

// TODO - Support vertical orientation
export function Divider({ orientation = 'horizontal' }: DividerProps) {
  const variantClasses = multiVariantStyles({
    orientation: orientation
  });
  const classes = classNames([variantClasses, styles.dividerBase]);
  // TODO - Check  with archs if this should be a polymorphic component and if the answer is yes, implement it
  return <span class={classes} role="separator" aria-orientation={orientation}></span>;
}
